import { TestimonialOwlCarousel } from './view';

export default TestimonialOwlCarousel;
